import {Controller} from "stimulus"

export default class extends Controller {

    updateReport(e) {
        const reportYear = document.getElementById("year")
        const reportMonth = document.getElementById("month")
        let reportUrl = 'monthly?year=' + reportYear.value + '&month=' + reportMonth.value;
        window.location.href = reportUrl
    }
}
